$(document).ready(function () {
	window.addBanner = function () {
		// $('.services-item').each(function (i, v) {
		// 	if (i === 6) {
		// 		$(window.banner).insertBefore(v);
		// 	}
		// });

		if ($('.services-middle_text').length) return

		$(window.banner).insertAfter($('.services-item').last())
	};

	$('.treatable-tab__link').each(function (index, element) {
		$(this).on('click', function (e) {
			e.preventDefault();
			if ($(this).hasClass('treatable-tab__link--active')) return false;
			$('.treatable-tab__link').removeClass('treatable-tab__link--active');
			$(this).addClass('treatable-tab__link--active');
			$('.treatable__content').hide();
			$('.treatable__content').eq(index).fadeIn();
		});
	});

	function eventListeners() {
		$(window).on('resize', function () {
			matchHeight();
		});
	}

	function matchHeight() {
		var groupName = $('.treatable__content'),
			groupHeights = [];

		groupName.css('min-height', 'auto');
		groupName.each(function () {
			groupHeights.push($(this).outerHeight());
		});

		var maxHeight = Math.max.apply(null, groupHeights);
		$('.treatable__content-wrap').css('min-height', maxHeight);
	}

	function equalHeight() {
		eventListeners();
		matchHeight();
	}

	equalHeight();
});

window.filterJS = function () {
	$(document).on('click', '.services-filters .boost-pfs-filter-option-title-heading', function (e) {
		if (e.hasOwnProperty('originalEvent')) {
			if ($(this).parents('.boost-pfs-filter-option-area').length) {
				$(
					'.services-filters .boost-pfs-filter-option-concern:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading'
				).click();
				$(
					'.services-filters .boost-pfs-filter-option-downtime:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading'
				).click();
				$(
					'.services-filters .boost-pfs-filter-option-price:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading'
				).click();
			} else if ($(this).parents('.boost-pfs-filter-option-concern').length) {
				$(
					'.services-filters .boost-pfs-filter-option-area:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading'
				).click();
				$(
					'.services-filters .boost-pfs-filter-option-downtime:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading'
				).click();
				$(
					'.services-filters .boost-pfs-filter-option-price:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading'
				).click();
			} else if ($(this).parents('.boost-pfs-filter-option-downtime').length) {
				$(
					'.services-filters .boost-pfs-filter-option-area:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading'
				).click();
				$(
					'.services-filters .boost-pfs-filter-option-concern:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading'
				).click();
				$(
					'.services-filters .boost-pfs-filter-option-price:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading'
				).click();
			} else if ($(this).parents('.boost-pfs-filter-option-price').length) {
				$(
					'.services-filters .boost-pfs-filter-option-area:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading'
				).click();
				$(
					'.services-filters .boost-pfs-filter-option-concern:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading'
				).click();
				$(
					'.services-filters .boost-pfs-filter-option-downtime:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading'
				).click();
			}
		}
	});
};
